import { hydrateImmutable, dehydrateImmutable } from "immutable-stringify";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { isLocalStorageAvailable } from "@services/IsLocalStorageAvailable";

import { IStoreValues } from "./reducers";

export const setLocalStorageHelper = (
  dispatch: ThunkActionDispatch,
  type: string,
  storeObject: IStoreValues,
  key: string,
) => {
  if (isLocalStorageAvailable()) {
    const dehydratedData = dehydrateImmutable(storeObject);
    localStorage.setItem(key, dehydratedData);
  }

  dispatch({
    type,
  });
};

export const setFromLocalStorageHelper = (
  dispatch: ThunkActionDispatch,
  type: string,
  key: string,
) => {
  const localStorageData = isLocalStorageAvailable()
    ? localStorage.getItem(key)
    : undefined;
  const parsedStorageData = JSON.parse(localStorageData || "{}");
  const payload = localStorageData
    ? hydrateImmutable(localStorageData)
    : undefined;

  if (payload?.get("executionDateTime") instanceof Date) {
    dispatch({
      type,
      payload: payload.set(
        "executionDateTime",
        parsedStorageData.executionDateTime,
      ),
    });

    return;
  }

  dispatch({
    type,
    payload,
  });
};

export const deleteLocalStorageHelper = (
  dispatch: ThunkActionDispatch,
  type: string,
  key: string,
) => {
  if (isLocalStorageAvailable()) {
    localStorage.removeItem(key);
  }

  dispatch({
    type,
  });
};

/**
 * `abortControllerHelper` provide necessary functionalities for aborting any request.
 * @returns () => AbortSignal
 */
export const abortControllerHelper = (): (() => AbortSignal) => {
  const controllers: AbortController[] = [];

  return function () {
    const newController = new AbortController();

    controllers.pop()?.abort();
    controllers.push(newController);

    return newController.signal;
  };
};
